import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { Box } from '@stitch-fix/mode-react';
import styles from './style.module.scss';
import AccountBadge from '../../AccountBadge';

interface DropdownControlProps {
  firstName: string;
  firstNameColor?: string;
  onClick?: () => void;
  theme?: string;
  circleColor?: number;
  isNameVisible?: boolean;
  isOpen?: boolean;
}

const cx = classNames.bind(styles);

const DropdownControl = forwardRef<HTMLButtonElement, DropdownControlProps>(
  (
    {
      firstName,
      firstNameColor = 'light',
      theme = '',
      circleColor = 0,
      isNameVisible = true,
      isOpen = false,
      ...buttonProps
    },
    ref,
  ) => {
    const themeString = theme === 'light' ? 'light-theme' : '';

    return (
      <div className={cx('full-height', themeString)}>
        <button
          {...buttonProps}
          ref={ref}
          type="button"
          className={cx('account-dropdown-button')}
          aria-haspopup="menu"
          aria-label={`${firstName || 'User'}'s profile menu`}
          aria-expanded={isOpen}
        >
          <AccountBadge circleColor={circleColor} text={firstName.charAt(0)} />
          <Box
            as="span"
            className={cx(
              firstNameColor === 'dark' ? 'dark-account-name' : 'account-name',
            )}
          >
            {isNameVisible && firstName}
          </Box>
        </button>
      </div>
    );
  },
);

export default DropdownControl;
